// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"85cb414f","513":"4e4a3d1d","703":"563724f0","787":"89239b24"}[chunkId] + ".chunk.js";
};